import './chpu-translit.scss';
import { xhr } from "../../../client/helper";

const form = document.querySelector('.chpu-translit__form');


if (form) {
    let time = 0;
    const input = form.querySelector('textarea');
    const result = document.querySelector('.chpu-translit__result');
    const handler = () => {
        clearTimeout(time);

        time = setTimeout(() => {
            const data = new FormData(form);
            const path = `/api/chpu-translit/?hash=${data.get('hash') || ''}&value=${data.get('value')}`;

            xhr('GET', path).then(response => {
                if (response.success && result) {
                    result.innerHTML = response.value;
                }
            });
        }, 300);
    };

    form.addEventListener('change', handler);

    if (input) {
        input.addEventListener('input', handler);
    }
}
